var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2_07_29-Drafts-list",
    transform: "translate(-1316.000000, -298.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(310.000000, 283.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/16/copy/green",
    transform: "translate(1006.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1111111,14.4 L4.88888889,14.4 C3.60022447,14.4 2.55555556,13.3254834 2.55555556,12 L2.55555556,4 C2.55555556,3.5581722 2.20733258,3.2 1.77777778,3.2 C1.34822297,3.2 1,3.5581722 1,4 L1,12 C1,14.209139 2.74111486,16 4.88888889,16 L11.1111111,16 C11.5406659,16 11.8888889,15.6418278 11.8888889,15.2 C11.8888889,14.7581722 11.5406659,14.4 11.1111111,14.4 Z M15,5.552 C14.9918984,5.47850792 14.9762557,5.40610446 14.9533333,5.336 L14.9533333,5.264 C14.9159369,5.1817438 14.8660541,5.10613187 14.8055556,5.04 L10.1388889,0.24 C10.074594,0.177772964 10.0010824,0.126464865 9.92111111,0.088 C9.89789429,0.0846081475 9.87432793,0.0846081475 9.85111111,0.088 C9.7721004,0.0413930837 9.68484038,0.011475363 9.59444444,0 L6.44444444,0 C5.15578003,0 4.11111111,1.0745166 4.11111111,2.4 L4.11111111,10.4 C4.11111111,11.7254834 5.15578003,12.8 6.44444444,12.8 L12.6666667,12.8 C13.9553311,12.8 15,11.7254834 15,10.4 L15,5.6 C15,5.6 15,5.6 15,5.552 Z M10.3333333,2.728 L12.3477778,4.8 L11.1111111,4.8 C10.6815563,4.8 10.3333333,4.4418278 10.3333333,4 L10.3333333,2.728 Z M13.4444444,10.4 C13.4444444,10.8418278 13.0962215,11.2 12.6666667,11.2 L6.44444444,11.2 C6.01488964,11.2 5.66666667,10.8418278 5.66666667,10.4 L5.66666667,2.4 C5.66666667,1.9581722 6.01488964,1.6 6.44444444,1.6 L8.77777778,1.6 L8.77777778,4 C8.77988132,4.27291459 8.82722691,4.5434608 8.91777778,4.8 C9.22736491,5.86666667 9.74720559,6.4 10.4772998,6.4 L13.4444444,6.4 L13.4444444,10.4 Z",
    id: "Shape-Copy-4",
    fill: "#2F665C",
    fillRule: "nonzero",
    opacity: 0.913866316
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.3580a8cb64d6f102959e95e20f041ac3.svg";
export { ForwardRef as ReactComponent };